import $kjgIr$intltablearAEmjs from "../intl/table/ar-AE.mjs";
import $kjgIr$intltablebgBGmjs from "../intl/table/bg-BG.mjs";
import $kjgIr$intltablecsCZmjs from "../intl/table/cs-CZ.mjs";
import $kjgIr$intltabledaDKmjs from "../intl/table/da-DK.mjs";
import $kjgIr$intltabledeDEmjs from "../intl/table/de-DE.mjs";
import $kjgIr$intltableelGRmjs from "../intl/table/el-GR.mjs";
import $kjgIr$intltableenUSmjs from "../intl/table/en-US.mjs";
import $kjgIr$intltableesESmjs from "../intl/table/es-ES.mjs";
import $kjgIr$intltableetEEmjs from "../intl/table/et-EE.mjs";
import $kjgIr$intltablefiFImjs from "../intl/table/fi-FI.mjs";
import $kjgIr$intltablefrFRmjs from "../intl/table/fr-FR.mjs";
import $kjgIr$intltableheILmjs from "../intl/table/he-IL.mjs";
import $kjgIr$intltablehrHRmjs from "../intl/table/hr-HR.mjs";
import $kjgIr$intltablehuHUmjs from "../intl/table/hu-HU.mjs";
import $kjgIr$intltableitITmjs from "../intl/table/it-IT.mjs";
import $kjgIr$intltablejaJPmjs from "../intl/table/ja-JP.mjs";
import $kjgIr$intltablekoKRmjs from "../intl/table/ko-KR.mjs";
import $kjgIr$intltableltLTmjs from "../intl/table/lt-LT.mjs";
import $kjgIr$intltablelvLVmjs from "../intl/table/lv-LV.mjs";
import $kjgIr$intltablenbNOmjs from "../intl/table/nb-NO.mjs";
import $kjgIr$intltablenlNLmjs from "../intl/table/nl-NL.mjs";
import $kjgIr$intltableplPLmjs from "../intl/table/pl-PL.mjs";
import $kjgIr$intltableptBRmjs from "../intl/table/pt-BR.mjs";
import $kjgIr$intltableptPTmjs from "../intl/table/pt-PT.mjs";
import $kjgIr$intltableroROmjs from "../intl/table/ro-RO.mjs";
import $kjgIr$intltableruRUmjs from "../intl/table/ru-RU.mjs";
import $kjgIr$intltableskSKmjs from "../intl/table/sk-SK.mjs";
import $kjgIr$intltableslSImjs from "../intl/table/sl-SI.mjs";
import $kjgIr$intltablesrSPmjs from "../intl/table/sr-SP.mjs";
import $kjgIr$intltablesvSEmjs from "../intl/table/sv-SE.mjs";
import $kjgIr$intltabletrTRmjs from "../intl/table/tr-TR.mjs";
import $kjgIr$intltableukUAmjs from "../intl/table/uk-UA.mjs";
import $kjgIr$intltablezhCNmjs from "../intl/table/zh-CN.mjs";
import $kjgIr$intltablezhTWmjs from "../intl/table/zh-TW.mjs";

var $b0fbbc5fdcc6603a$exports = {};


































$b0fbbc5fdcc6603a$exports = {
    "ar-AE": $kjgIr$intltablearAEmjs,
    "bg-BG": $kjgIr$intltablebgBGmjs,
    "cs-CZ": $kjgIr$intltablecsCZmjs,
    "da-DK": $kjgIr$intltabledaDKmjs,
    "de-DE": $kjgIr$intltabledeDEmjs,
    "el-GR": $kjgIr$intltableelGRmjs,
    "en-US": $kjgIr$intltableenUSmjs,
    "es-ES": $kjgIr$intltableesESmjs,
    "et-EE": $kjgIr$intltableetEEmjs,
    "fi-FI": $kjgIr$intltablefiFImjs,
    "fr-FR": $kjgIr$intltablefrFRmjs,
    "he-IL": $kjgIr$intltableheILmjs,
    "hr-HR": $kjgIr$intltablehrHRmjs,
    "hu-HU": $kjgIr$intltablehuHUmjs,
    "it-IT": $kjgIr$intltableitITmjs,
    "ja-JP": $kjgIr$intltablejaJPmjs,
    "ko-KR": $kjgIr$intltablekoKRmjs,
    "lt-LT": $kjgIr$intltableltLTmjs,
    "lv-LV": $kjgIr$intltablelvLVmjs,
    "nb-NO": $kjgIr$intltablenbNOmjs,
    "nl-NL": $kjgIr$intltablenlNLmjs,
    "pl-PL": $kjgIr$intltableplPLmjs,
    "pt-BR": $kjgIr$intltableptBRmjs,
    "pt-PT": $kjgIr$intltableptPTmjs,
    "ro-RO": $kjgIr$intltableroROmjs,
    "ru-RU": $kjgIr$intltableruRUmjs,
    "sk-SK": $kjgIr$intltableskSKmjs,
    "sl-SI": $kjgIr$intltableslSImjs,
    "sr-SP": $kjgIr$intltablesrSPmjs,
    "sv-SE": $kjgIr$intltablesvSEmjs,
    "tr-TR": $kjgIr$intltabletrTRmjs,
    "uk-UA": $kjgIr$intltableukUAmjs,
    "zh-CN": $kjgIr$intltablezhCNmjs,
    "zh-TW": $kjgIr$intltablezhTWmjs
};


export {$b0fbbc5fdcc6603a$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
